export default __webpack_public_path__ + "static/media/large.21d7c97b.jpg";